import type React from "react";
import styles from "./HealthStatusContentIconContainer.module.less";
type HealthStatusContentIconContainerProps = {
    children: React.ReactNode;
};
export function HealthStatusContentIconContainer({ children }: HealthStatusContentIconContainerProps) {
    return <div className={styles.healthStatusIconContainer}>{children}</div>;
}
